function Native() {}

const WebView = window.ReactNativeWebView;

function postAction(action: string, data: any) {
  WebView && WebView.postMessage(JSON.stringify({ ...data, action: action }));
}

function postMessage(message: string) {
  WebView && WebView.postMessage(message);
}

function postURL(url: string) {
  WebView && WebView.postMessage(JSON.stringify({ url: url, action: 'URL.open' }));
}

function postShareURL(url: string) {
  WebView && WebView.postMessage(JSON.stringify({ url: url, action: 'ShareURL' }));
}


const hasWebView = () => {
  return WebView ? true : false;
};

export default Native;
Native.postAction = postAction;
Native.postMessage = postMessage;
Native.postURL = postURL;
Native.postShareURL = postShareURL;
Native.hasWebView = hasWebView;
Native.WebView = WebView;
